import { Column, Columns, Flex, Text } from "@dna/react";
import { IconButton, makeStyles } from "@material-ui/core";
import React from "react";
import { ReactComponent as WarningFill } from "../../images/warning-fill.svg";
import styles from "./Layout.module.scss";

export const WarningBanner = (props: {text: string})=>{

  const useStyles = makeStyles({
    redFill: { fill: '#D93923'}
  });
  const classes = useStyles();
  
  return (
          <Columns
            css={{
              backgroundColor: "orange-lighter",
            }}
            UNSAFE_style={{
              wordBreak: "break-word",
            }}
          >
            <Column
              width="content"
            >
              <Flex UNSAFE_className={styles.warningIconColumn} >
              <WarningFill className={classes.redFill} ></WarningFill>
              </Flex>
            </Column>

            <Column
            >
              <Flex  UNSAFE_className={styles.warningTextColumn}>
                <Text
                  level="small"
                  css={{
                    color: "critical",
                  }}
                  as="strong"
                >
                  {props.text}
                </Text>
              </Flex>
            </Column>
          </Columns>
  );
}